import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import "./App.css";
import PrivacyPolicy from "./components/PrivacyPolicy";
import ContactForm from "./components/ContactForm";

const App = () => {
  return (
    <Router>
      <div id="root">
        <nav className="nav-bar">
          <Link to="/" className="nav-link">
            Privacy Policy
          </Link>
          <Link to="/contact" className="nav-link">
            Contact Us
          </Link>
        </nav>

        <Routes>
          <Route path="/" element={<PrivacyPolicy />} />
          <Route path="/contact" element={<ContactForm />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
